(function () {
  const drawerEl = () => document.querySelector('cart-drawer');

  // --- Hilfsfunktion: Dawn-konforme Sections-Liste besorgen
  function sectionsList() {
    const cd = drawerEl();
    if (!cd || typeof cd.getSectionsToRender !== 'function') return [];
    // WICHTIG: Dawn erwartet "section", nicht "id"
    return cd.getSectionsToRender().map(s => s.section || s.id).filter(Boolean);
  }

  // ----- Eingabe sperren (nur für non-Start-Smart Bundles) -----
  function hardLockBundleInputs(root = document) {
    root.querySelectorAll('.cart-item--bundle:not(.cart-item--start-smart) .quantity__input').forEach(inp => {
      inp.setAttribute('readonly','readonly');
      inp.setAttribute('disabled','disabled');
      inp.setAttribute('inputmode','none');
      inp.setAttribute('aria-disabled','true');
      inp.tabIndex = -1;
      const block = ev => { ev.preventDefault(); ev.stopPropagation(); inp.blur(); };
      ['click','focus','keydown','keypress','keyup','input','paste','wheel','change'].forEach(evt => {
        inp.addEventListener(evt, block, { passive:false });
      });
    });
  }

  async function removeKeys(keys, row) {
  if (!keys || !keys.length) {
    console.warn('[EDM Bundles] removeKeys called with empty keys array');
    return;
  }

  // UI: Spinner während Update
  if (row) {
    row.setAttribute('aria-busy', 'true');
    const spinner = row.querySelector('.loading__spinner');
    const priceWrap = row.querySelector('.cart-item__price-wrapper');
    spinner && spinner.classList.remove('hidden');
    if (priceWrap) priceWrap.style.visibility = 'hidden';
  }

  const cd = document.querySelector('cart-drawer');
  // Nutze Dawn's getSectionsToRender wenn verfügbar, sonst Fallback auf Core API SECTION_IDS
  let sections = [];
  if (cd?.getSectionsToRender) {
    sections = cd.getSectionsToRender().map(s => s.section || s.id).filter(Boolean);
  } else if (window.EDUMON?.SECTION_IDS) {
    sections = window.EDUMON.SECTION_IDS.slice(0, 5);
  } else {
    // Fallback: Standard Sections
    sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'cart-footer'];
  }
  const sectionsCsv = sections.join(',');

  // Wichtig: sections (+ optional sections_url) mitgeben, damit die Antwort
  // sowohl Cart-Daten (item_count, ...), als auch fertige HTML-Snippets enthält.
  // sections_url sollte pathname + search enthalten (wie in Core API)
    const payload = {
      updates: Object.fromEntries(keys.map(k => [k, 0])),
      sections: sectionsCsv,
      sections_url: window.location.pathname + window.location.search
    };


  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(payload)
  });

  const parsed = await res.json(); // enthält u.a. { item_count, sections: { ... } }

  // Dawn-internes Re-Rendern aller betroffenen Bereiche:
  if (cd?.renderContents) {
    cd.renderContents(parsed);
    // Sicherheitsgurt: Klassen-Status am Wrapper synchronisieren
    if (typeof parsed.item_count === 'number') {
      cd.classList.toggle('is-empty', parsed.item_count === 0);
    }
    
    // Core API Integration: Warte auf Hydration und feuere Events
    // Dies ermöglicht anderen Modulen (z.B. Start-Smart) zu reagieren
    setTimeout(() => {
      // Nutze Core API wenn verfügbar, sonst manuell Events feuern
      if (window.EDUMON && typeof window.EDUMON.updateUI === 'function') {
        window.EDUMON.updateUI();
      }
      
      // Feuere Standard-Events für andere Module
      document.dispatchEvent(new CustomEvent('cart:sections:hydrated', {
        detail: { source: 'edm-bundles', sections: parsed.sections ? Object.keys(parsed.sections) : [] }
      }));
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { source: 'edm-bundles' }
      }));
    }, 100);
  }

  // Bundle-Inputs wieder sperren (nach neuem Markup!)
  hardLockBundleInputs();
}

  // Delegation: Bundle-Gruppen entfernen
  document.addEventListener('click', async (e) => {
    const row = e.target.closest('.cart-item--bundle');
    if (!row) return;

    const btn = e.target.closest('[data-remove-bundle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    // Special handling for Start-Smart bundles: Decrement instead of remove
    const isStartSmart = row.classList.contains('cart-item--start-smart') || 
                         row.dataset.bundleType === 'start-smart-global';
    
    if (isStartSmart) {
      const bundleQty = parseInt(row.dataset.bundleQuantity || '1', 10);
      const handleA = 'schnapp-zu-mein-erstes-angel-abc';
      const handleB = 'nicht-vergessen-das-such-und-merkspiel';
      
      // Get current cart
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      
      const updates = {};
      let foundA = 0;
      let foundB = 0;
      
      // Find and decrement A and B items
      for (const item of cart.items) {
        if (item.product_handle === handleA && foundA < bundleQty) {
          const decrement = Math.min(bundleQty - foundA, item.quantity);
          updates[item.key] = item.quantity - decrement;
          foundA += decrement;
        } else if (item.product_handle === handleB && foundB < bundleQty) {
          const decrement = Math.min(bundleQty - foundB, item.quantity);
          updates[item.key] = item.quantity - decrement;
          foundB += decrement;
        }
        if (foundA >= bundleQty && foundB >= bundleQty) break;
      }
      
      // Remove PDF if present
      const handlePDF = 'edumon-eltern-leitfaden';
      for (const item of cart.items) {
        if (item.product_handle === handlePDF && item.final_price === 0) {
          updates[item.key] = 0;
          break;
        }
      }
      
      if (Object.keys(updates).length > 0) {
        const cd = drawerEl();
        let sections = [];
        if (cd?.getSectionsToRender) {
          sections = cd.getSectionsToRender().map(s => s.section || s.id).filter(Boolean);
        } else if (window.EDUMON?.SECTION_IDS) {
          sections = window.EDUMON.SECTION_IDS.slice(0, 5);
        } else {
          sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'cart-footer'];
        }
        const sectionsCsv = sections.join(',');
        
        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates, sections: sectionsCsv, sections_url: window.location.pathname + window.location.search })
        });
        
        const updateData = await updateRes.json();
        if (cd?.renderContents) {
          cd.renderContents(updateData);
          setTimeout(() => {
            if (window.EDUMON?.updateUI) window.EDUMON.updateUI();
            document.dispatchEvent(new CustomEvent('cart:sections:hydrated', {
              detail: { source: 'edm-bundles-smart-remove', sections: updateData.sections ? Object.keys(updateData.sections) : [] }
            }));
          }, 100);
        }
        hardLockBundleInputs();
        initializeStartSmartInputs();
        return;
      }
    }

    // Default: Remove all keys (for generic bundles)
    const keys = (row.dataset.keysAll || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    removeKeys(keys, row);
  }, true);

  // Event-Listener für sofortiges Locking nach Drawer-Updates
  function handleSectionsHydrated() {
    hardLockBundleInputs();
  }
  
  // Start-Smart Quantity Change Handler: Add/Remove Product A and B pairs
  // Context7: Event delegation - works with Dawn's quantity-popover component
  async function handleStartSmartQuantityChange(event) {
    const input = event.target;
    // Only handle Start-Smart bundle inputs
    const row = input.closest('.cart-item--start-smart');
    if (!row || !input.classList.contains('quantity__input')) return;
    
    // Skip if this is a remainder input (handled separately)
    if (input.classList.contains('js-smart-remainder-change')) return;
    
    // Context7: Prevent default form submission - we handle updates via AJAX
    event.preventDefault();
    event.stopPropagation();
    
    const newQty = parseInt(input.value, 10);
    
    // Validate input first
    if (isNaN(newQty) || newQty < 1) {
      // Reset to stored quantity from dataset or row data attribute
      const storedQty = parseInt(
        input.dataset.bundleQuantity || 
        row.dataset.bundleQuantity || 
        input.getAttribute('data-bundle-quantity') ||
        '1', 
        10
      );
      input.value = storedQty;
      return;
    }
    
    // Get old quantity from dataset (stored from previous change or initialization)
    // Context7: Always use dataset/attribute, never current input.value (which is the new value)
    // Priority: input dataset > row dataset > row data attribute > fallback to 1
    let oldQty = parseInt(
      input.dataset.bundleQuantity || 
      row.dataset.bundleQuantity || 
      row.getAttribute('data-bundle-quantity') ||
      '1', 
      10
    );
    
    // If dataset not initialized yet, initialize from row's data attribute (from server)
    if (!input.dataset.bundleQuantity && !row.dataset.bundleQuantity) {
      const rowQty = row.getAttribute('data-bundle-quantity');
      if (rowQty) {
        oldQty = parseInt(rowQty, 10);
        // Store it for next change
        input.dataset.bundleQuantity = String(oldQty);
        row.dataset.bundleQuantity = String(oldQty);
      } else {
        // Fallback: assume no change if we can't determine old value
        console.warn('[EDM Bundles] Could not determine old quantity for Start-Smart bundle');
        input.dataset.bundleQuantity = String(newQty);
        return;
      }
    }
    
    const delta = newQty - oldQty;
    if (delta === 0) {
      // Update dataset even if no change (for consistency)
      input.dataset.bundleQuantity = String(newQty);
      if (row.dataset) {
        row.dataset.bundleQuantity = String(newQty);
      }
      return;
    }
    
    // Prevent concurrent updates
    if (input.disabled) return;
    input.disabled = true;
    
    try {
      // Get current cart to find variant IDs
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      
      const handleA = 'schnapp-zu-mein-erstes-angel-abc';
      const handleB = 'nicht-vergessen-das-such-und-merkspiel';
      
      // Find variant IDs for Product A and B
      // Context7: Robust validation - ensure we have valid variant IDs before proceeding
      let variantIdA = null;
      let variantIdB = null;
      
      for (const item of cart.items) {
        if (item.product_handle === handleA && !variantIdA) {
          variantIdA = Number(item.variant_id);
        } else if (item.product_handle === handleB && !variantIdB) {
          variantIdB = Number(item.variant_id);
        }
        if (variantIdA && variantIdB) break;
      }
      
      // Context7: Fail Fast - Validate variant IDs before making API calls
      if (!variantIdA || !variantIdB || isNaN(variantIdA) || isNaN(variantIdB)) {
        console.error('[EDM Bundles] Could not find valid variant IDs for Start-Smart products', {
          variantIdA,
          variantIdB,
          cartItems: cart.items.map(i => ({ handle: i.product_handle, variant_id: i.variant_id }))
        });
        input.value = oldQty;
        if (input.dataset) {
          input.dataset.bundleQuantity = String(oldQty);
        }
        return;
      }
      
      const cd = drawerEl();
      let sections = [];
      if (cd?.getSectionsToRender) {
        sections = cd.getSectionsToRender().map(s => s.section || s.id).filter(Boolean);
      } else if (window.EDUMON?.SECTION_IDS) {
        sections = window.EDUMON.SECTION_IDS.slice(0, 5);
      } else {
        sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'cart-footer'];
      }
      const sectionsCsv = sections.join(',');
      
      if (delta > 0) {
        // Add: Add delta pairs (as orphans, no bundle_key)
        const items = [];
        for (let i = 0; i < delta; i++) {
          items.push({ id: variantIdA, quantity: 1 });
          items.push({ id: variantIdB, quantity: 1 });
        }
        
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items, sections: sectionsCsv, sections_url: window.location.pathname + window.location.search })
        });
        
        // Context7: Validate response before processing
        if (!addRes.ok) {
          const errorData = await addRes.json().catch(() => ({ message: `HTTP ${addRes.status}` }));
          throw new Error(errorData.message || errorData.description || `Cart add failed: ${addRes.status}`);
        }
        
        const addData = await addRes.json();
        
        // Context7: Validate response data structure
        if (!addData || typeof addData !== 'object') {
          throw new Error('Invalid response from cart/add.js');
        }
        
        if (cd?.renderContents) {
          cd.renderContents(addData);
          setTimeout(() => {
            // Context7: Sync state after render to ensure input value matches server truth
            syncStartSmartState();
            if (window.EDUMON?.updateUI) window.EDUMON.updateUI();
            document.dispatchEvent(new CustomEvent('cart:sections:hydrated', {
              detail: { source: 'edm-bundles-smart', sections: addData.sections ? Object.keys(addData.sections) : [] }
            }));
          }, 100);
        }
      } else {
        // Remove: Find and remove abs(delta) pairs
        const updates = {};
        let toRemoveA = Math.abs(delta);
        let toRemoveB = Math.abs(delta);
        
        for (const item of cart.items) {
          if (toRemoveA > 0 && item.product_handle === handleA) {
            const removeQty = Math.min(toRemoveA, item.quantity);
            updates[item.key] = item.quantity - removeQty;
            toRemoveA -= removeQty;
          } else if (toRemoveB > 0 && item.product_handle === handleB) {
            const removeQty = Math.min(toRemoveB, item.quantity);
            updates[item.key] = item.quantity - removeQty;
            toRemoveB -= removeQty;
          }
          if (toRemoveA === 0 && toRemoveB === 0) break;
        }
        
        // Context7: Validate updates object has valid keys (strings)
        const validUpdates = {};
        for (const [key, qty] of Object.entries(updates)) {
          if (key && typeof key === 'string' && typeof qty === 'number' && qty >= 0) {
            validUpdates[key] = qty;
          }
        }
        
        if (Object.keys(validUpdates).length === 0) {
          throw new Error('No valid updates to apply');
        }
        
        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: validUpdates, sections: sectionsCsv, sections_url: window.location.pathname + window.location.search })
        });
        
        // Context7: Validate response before processing
        if (!updateRes.ok) {
          const errorData = await updateRes.json().catch(() => ({ message: `HTTP ${updateRes.status}` }));
          throw new Error(errorData.message || errorData.description || `Cart update failed: ${updateRes.status}`);
        }
        
        const updateData = await updateRes.json();
        
        // Context7: Validate response data structure
        if (!updateData || typeof updateData !== 'object') {
          throw new Error('Invalid response from cart/update.js');
        }
        
        if (cd?.renderContents) {
          cd.renderContents(updateData);
          setTimeout(() => {
            // Context7: Sync state after render to ensure input value matches server truth
            syncStartSmartState();
            if (window.EDUMON?.updateUI) window.EDUMON.updateUI();
            document.dispatchEvent(new CustomEvent('cart:sections:hydrated', {
              detail: { source: 'edm-bundles-smart', sections: updateData.sections ? Object.keys(updateData.sections) : [] }
            }));
          }, 100);
        }
      }
      
      // Context7: State will be synced by syncStartSmartState() after render
      // Don't update dataset here - let syncStartSmartState() handle it after render completes
      hardLockBundleInputs();
      // No need to re-attach listeners - event delegation handles it
    } catch (error) {
      console.error('[EDM Bundles] Start-Smart quantity change failed', error);
      
      // Context7: Display user-friendly error message
      const errorEl = row.querySelector('.cart-item__error');
      const errorTextEl = row.querySelector('.cart-item__error-text');
      if (errorEl && errorTextEl) {
        const errorMessage = error.message || 'Beim Aktualisieren deines Warenkorbs ist ein Fehler aufgetreten. Bitte versuche es erneut.';
        errorTextEl.textContent = errorMessage;
        errorEl.hidden = false;
        errorEl.removeAttribute('hidden');
        
        // Hide error after 5 seconds
        setTimeout(() => {
          if (errorEl) {
            errorEl.hidden = true;
          }
        }, 5000);
      }
      
      // Reset input to old value
      input.value = oldQty;
      if (input.dataset) {
        input.dataset.bundleQuantity = String(oldQty);
      }
      if (row.dataset) {
        row.dataset.bundleQuantity = String(oldQty);
      }
    } finally {
      input.disabled = false;
    }
  }
  
  // Context7: Event delegation for Start-Smart quantity inputs
  // This approach works with Dawn's quantity-popover component without breaking bindings
  // No need to clone/replace elements - delegation handles dynamically added elements
  // Dawn's quantity-input fires 'change' events when +/- buttons are clicked
  // Browsers fire 'change' events when input loses focus (direct entry)
  function initializeStartSmartDelegation() {
    // Use event delegation on document to catch all Start-Smart quantity changes
    // This includes changes from +/- buttons (via Dawn's quantity-input) and direct input
    document.addEventListener('change', handleStartSmartQuantityChange, true);
  }
  
  // Initialize dataset values for existing inputs (for delta calculation)
  function initializeStartSmartInputs(root = document) {
    root.querySelectorAll('.cart-item--start-smart .quantity__input:not(.js-smart-remainder-change)').forEach(inp => {
      // Store initial quantity for delta calculation
      if (!inp.dataset.bundleQuantity) {
        inp.dataset.bundleQuantity = inp.value || '1';
      }
    });
  }
  
  // Context7: Post-render synchronization - sync Start-Smart state with actual cart after render
  // This ensures the input value and dataset stay in sync with server-rendered truth
  function syncStartSmartState(root = document) {
    root.querySelectorAll('.cart-item--start-smart .quantity__input:not(.js-smart-remainder-change)').forEach(inp => {
      const row = inp.closest('.cart-item--start-smart');
      if (!row) return;
      
      // Context7: Trust server-rendered value as source of truth after render
      const serverValue = parseInt(inp.value || '1', 10);
      
      // Update dataset to match server value
      if (inp.dataset) {
        inp.dataset.bundleQuantity = String(serverValue);
      }
      
      // Update row dataset for consistency
      if (row.dataset) {
        row.dataset.bundleQuantity = String(serverValue);
      }
      
      // Also sync data-bundle-quantity attribute if present
      const rowQtyAttr = row.getAttribute('data-bundle-quantity');
      if (rowQtyAttr && parseInt(rowQtyAttr, 10) !== serverValue) {
        row.setAttribute('data-bundle-quantity', String(serverValue));
      }
    });
  }
  
  // Handle remainder input changes (for Start-Smart items that are partially in bundle)
  async function handleRemainderInputChange(event) {
    const input = event.target;
    if (!input.classList.contains('js-smart-remainder-change')) return;
    
    const originalKey = input.dataset.originalKey;
    const offset = parseInt(input.dataset.smartOffset || '0', 10);
    const newRemainder = parseInt(input.value, 10);
    
    if (!originalKey || isNaN(newRemainder) || newRemainder < 0) {
      // Reset to current value
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      const item = cart.items.find(i => i.key === originalKey);
      if (item) {
        input.value = item.quantity - offset;
      }
      return;
    }
    
    // Calculate total quantity: remainder + offset
    const totalQty = newRemainder + offset;
    
    // Prevent concurrent updates
    if (input.disabled) return;
    input.disabled = true;
    
    try {
      const cd = drawerEl();
      let sections = [];
      if (cd?.getSectionsToRender) {
        sections = cd.getSectionsToRender().map(s => s.section || s.id).filter(Boolean);
      } else if (window.EDUMON?.SECTION_IDS) {
        sections = window.EDUMON.SECTION_IDS.slice(0, 5);
      } else {
        sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'cart-footer'];
      }
      const sectionsCsv = sections.join(',');
      
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ 
          updates: { [originalKey]: totalQty },
          sections: sectionsCsv,
          sections_url: window.location.pathname + window.location.search
        })
      });
      
      const updateData = await updateRes.json();
      if (cd?.renderContents) {
        cd.renderContents(updateData);
        setTimeout(() => {
          if (window.EDUMON?.updateUI) window.EDUMON.updateUI();
          document.dispatchEvent(new CustomEvent('cart:sections:hydrated', {
            detail: { source: 'edm-bundles-remainder', sections: updateData.sections ? Object.keys(updateData.sections) : [] }
          }));
        }, 100);
      }
      
      hardLockBundleInputs();
      initializeStartSmartInputs();
      attachRemainderListeners();
    } catch (error) {
      console.error('[EDM Bundles] Remainder input change failed', error);
      // Reset input value on error
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartRes.json();
      const item = cart.items.find(i => i.key === originalKey);
      if (item) {
        input.value = item.quantity - offset;
      }
    } finally {
      input.disabled = false;
    }
  }
  
  // Attach remainder input listeners
  function attachRemainderListeners(root = document) {
    root.querySelectorAll('.js-smart-remainder-change').forEach(inp => {
      // Remove existing listener if any (prevent duplicates)
      const newInp = inp.cloneNode(true);
      newInp.dataset.originalKey = inp.dataset.originalKey;
      newInp.dataset.smartOffset = inp.dataset.smartOffset;
      inp.parentNode.replaceChild(newInp, inp);
      // Attach change listener
      newInp.addEventListener('change', handleRemainderInputChange);
    });
  }
  
  // Initialize event delegation once (works for all current and future elements)
  initializeStartSmartDelegation();
  
  document.addEventListener('DOMContentLoaded', () => {
    hardLockBundleInputs(document);
    // Context7: Sync state on initial load
    syncStartSmartState(document);
    initializeStartSmartInputs(document);
    attachRemainderListeners(document);
  });
  document.addEventListener('shopify:section:load', (ev) => {
    hardLockBundleInputs(ev.target || document);
    // Context7: Sync state after section load
    syncStartSmartState(ev.target || document);
    initializeStartSmartInputs(ev.target || document);
    attachRemainderListeners(ev.target || document);
  });
  document.addEventListener('cart:sections:hydrated', () => {
    handleSectionsHydrated();
    // Context7: Sync Start-Smart state after cart sections are hydrated
    syncStartSmartState();
    initializeStartSmartInputs();
    attachRemainderListeners();
  });
})();
